module.exports = __webpack_public_path__ + "img/_constmap2.332ed49a.png";